"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstagramIcon = exports.LinkIcon = exports.WhatsappIcon = exports.TwitterIcon = exports.TelegramIcon = exports.FacebookMessengerIcon = exports.FacebookIcon = exports.EmailIcon = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var EmailIcon = function EmailIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '60%' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
  }));
};

exports.EmailIcon = EmailIcon;

var FacebookIcon = function FacebookIcon(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? '60%' : _ref2$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 512"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
  }));
};

exports.FacebookIcon = FacebookIcon;

var FacebookMessengerIcon = function FacebookMessengerIcon(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? '60%' : _ref3$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M224 32C15.9 32-77.5 278 84.6 400.6V480l75.7-42c142.2 39.8 285.4-59.9 285.4-198.7C445.8 124.8 346.5 32 224 32zm23.4 278.1L190 250.5 79.6 311.6l121.1-128.5 57.4 59.6 110.4-61.1-121.1 128.5z"
  }));
};

exports.FacebookMessengerIcon = FacebookMessengerIcon;

var TelegramIcon = function TelegramIcon(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? '60%' : _ref4$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
  }));
};

exports.TelegramIcon = TelegramIcon;

var TwitterIcon = function TwitterIcon(_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? '60%' : _ref5$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
  }));
};

exports.TwitterIcon = TwitterIcon;

var WhatsappIcon = function WhatsappIcon(_ref6) {
  var _ref6$size = _ref6.size,
      size = _ref6$size === void 0 ? '60%' : _ref6$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
  }));
};

exports.WhatsappIcon = WhatsappIcon;

var LinkIcon = function LinkIcon(_ref7) {
  var _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? '60%' : _ref7$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M337.5,448c-5.7,0-11.4-1.7-16.4-5.2c-5.6-3.9-10.8-8.5-15.5-13.5l-19.3-20.6c-48.9-52.1-46.2-134.3,5.9-183.2l95-89.1 c52.1-48.9,134.3-46.2,183.2,5.9c48.9,52.1,46.2,134.3-5.9,183.2l-31.8,29.8c-11.5,10.8-29.6,10.2-40.4-1.3 c-10.8-11.5-10.2-29.6,1.3-40.4l31.8-29.8c29.2-27.3,30.7-73.3,3.3-102.5c-27.3-29.2-73.3-30.7-102.5-3.3l-95,89.1 c-29.2,27.3-30.7,73.3-3.3,102.5l19.3,20.6c2,2.2,4.3,4.1,6.7,5.9c12.9,9.1,16,26.9,6.9,39.8C355.3,443.8,346.5,448,337.5,448z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M245.8,617.8c-34.6,0-69.1-13.7-94.6-40.9c-48.9-52.1-46.2-134.3,5.9-183.2l31.8-29.8c11.5-10.8,29.6-10.2,40.4,1.3 c10.8,11.5,10.2,29.6-1.3,40.4l-31.8,29.8c-29.2,27.3-30.7,73.3-3.3,102.5c27.3,29.2,73.3,30.7,102.5,3.3l95-89.1 c29.2-27.3,30.7-73.3,3.3-102.5L374.4,329c-2-2.2-4.3-4.1-6.7-5.9c-12.9-9.1-16-26.9-6.9-39.8c9.1-12.9,26.9-16,39.8-6.9 c5.6,3.9,10.8,8.5,15.5,13.5l19.3,20.6c48.9,52.1,46.2,134.3-5.9,183.2l-95,89.1C309.5,606.3,277.6,617.8,245.8,617.8z"
  })));
};

exports.LinkIcon = LinkIcon;

var InstagramIcon = function InstagramIcon(_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? '60%' : _ref8$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.486 40.912"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M95.09,109.768c.137-.971.242-1.947.417-2.911.991-5.459,4.855-9.173,10.381-9.364,6.654-.229,13.327-.241,19.98,0a10.692,10.692,0,0,1,10.558,10.687q.3,9.583,0,19.182a10.691,10.691,0,0,1-10.558,10.687c-6.653.24-13.328.246-19.98,0-6.016-.226-10.174-4.69-10.576-10.715-.035-.521-.147-1.038-.223-1.557Zm20.749,24.713c3.045,0,6.092.091,9.133-.021,4.767-.177,7.7-3.022,7.811-7.785q.207-8.9,0-17.812c-.111-4.762-3.046-7.673-7.811-7.775q-9.072-.192-18.151,0c-4.729.1-7.67,2.952-7.8,7.661q-.245,9.014,0,18.039c.128,4.709,3.069,7.5,7.8,7.671C109.823,134.572,112.832,134.482,115.839,134.482Zm0,0",
    transform: "translate(-95.09 -97.317)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M184.564,174a10.572,10.572,0,1,0,10.572,10.571A10.572,10.572,0,0,0,184.564,174Zm0,17.5a6.932,6.932,0,1,1,6.932-6.932A6.932,6.932,0,0,1,184.564,191.5Zm0,0",
    transform: "translate(-163.821 -164.111)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M328.315,153.258a2.515,2.515,0,1,1-2.515-2.515A2.515,2.515,0,0,1,328.315,153.258Zm0,0",
    transform: "translate(-293.868 -143.855)"
  }));
};

exports.InstagramIcon = InstagramIcon;